import React from 'react';
import i18next from 'i18next';
import Icon from '../Icon/Icon';
import vkIcon from 'icons/vk.svg';
import telegramIcon from 'icons/telegram.svg';
import instagramIcon from 'icons/instagram.svg';

export default class SocialIcons extends React.PureComponent {
  render() {
    return (
      <div className="soc-icons">
        <span>{i18next.t('socials_title')}</span>
        <a
          href="https://vk.com/super.xbet"
          target="_blank"
          className="text-icon"
        >
          <Icon className="text-icon__icon" glyph={vkIcon} />
        </a>
        <a
          href="https://t.me/superxbet_bot"
          target="_blank"
          className="text-icon"
        >
          <Icon className="text-icon__icon" glyph={telegramIcon} />
        </a>
        <a
          href="https://www.instagram.com/superx.bet/"
          target="_blank"
          className="text-icon"
        >
          <Icon className="text-icon__icon" glyph={instagramIcon} />
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/SocIcons/SocIcons.jsx